import router, { resetRouter } from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import '@/components/NProgress/nprogress.less' // progress bar custom style
import { getToken } from '@/utils/auth'
import { LOGIN_PATH, DEFAULT_HOME_PATH, VIDEO_CONTROL_SINGLE_MENU_PATH } from '@/config/constants'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const allowList = ['login', 'register', 'registerResult', 'flvPlayer'] // no redirect allowList
const loginRoutePath = LOGIN_PATH
const defaultRoutePath = DEFAULT_HOME_PATH

router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  /* has token */
  const token = getToken()
  if (token) {
    if (to.path === loginRoutePath) {
      next({ path: defaultRoutePath })
      NProgress.done()
    } else {
      if (!store.getters.roles || store.getters.roles.length === 0) {
        store
          .dispatch('GetUserData').then(res => {
            // 根据用户权限信息生成可访问的路由表
            store.dispatch('GenerateRoutes', { token, ...res }).then(() => {
              // 动态新增可访问路由表
              // VueRouter@3.5.0+ New API
              resetRouter() // 重置路由 防止退出重新登录或者 token 过期后页面未刷新，导致的路由重复新增
              store.getters.addRouters.forEach(r => {
                router.addRoute(r)
              })
              // 请求带有 redirect 重定向时，登录自动重定向到该地址
              const redirect = decodeURIComponent(from.query.redirect || to.path)
              if (res.menuList && res.menuList.length === 1 && res.menuList[0] === 'control-videoControl') {
                next({ path: VIDEO_CONTROL_SINGLE_MENU_PATH })
              } else if (to.path === redirect) {
                // set the replace: true so the navigation will not leave a history record
                next({ ...to, replace: true })
              } else {
                // 跳转到目的路由
                next({ path: redirect })
              }
            })
          })
          .catch(() => {
            NProgress.done()
            next({ path: loginRoutePath, query: { redirect: to.fullPath }})
          })
      } else {
        next()
      }
    }
  } else {
    if (allowList.includes(to.name)) {
      // 在免登录名单，直接进入
      next()
    } else {
      next({ path: loginRoutePath, query: { redirect: to.fullPath }})
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
